import { render, staticRenderFns } from "./LoanableIcon.vue?vue&type=template&id=3dbd535c&scoped=true"
import script from "./LoanableIcon.vue?vue&type=script&lang=js"
export * from "./LoanableIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dbd535c",
  null
  
)

export default component.exports